<mat-dialog-content>
  @if (data.emailAvailable) {
    {{ 'NPS_CARD.NPS_RESEND_CONFIRMATION.TITLE' | translate }}
  } @else {
    {{ 'NPS_CARD.NPS_RESEND_CONFIRMATION.EMAIL_NOT_FOUND' | translate }}
  }
</mat-dialog-content>
<mat-dialog-actions>
  @if (data.emailAvailable) {
    <button mat-stroked-button mat-dialog-close>
      {{ 'COMMON.ACTION_LABELS.CANCEL' | translate }}
    </button>
    <button (click)="resendNPSRequest()" mat-flat-button color="primary" mat-dialog-close>
      {{ 'NPS_CARD.NPS_RESEND_CONFIRMATION.RESEND_BUTTON' | translate }}
    </button>
  } @else {
    <button mat-flat-button color="primary" mat-dialog-close>
      {{ 'COMMON.ACTION_LABELS.CLOSE' | translate }}
    </button>
  }
</mat-dialog-actions>
